import { getTutorLessonDurationTest } from '@/api/classtable'
import { isToday } from 'date-fns'

const classtable = {
  namespaced: true,

  state: {
    viewRange: {
      start: new Date(),
      end: new Date()
    },
    events: [],
    currentView: 0, // [day, week]
    currentDate: new Date(),
    loading: false,
    hadInited: false
  },
  mutations: {
    SET_VIEW_RANGE: (state, viewRange) => {
      state.viewRange = viewRange
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_CURRENT_VIEW: (state, view) => {
      state.currentView = view
    },
    SET_CURRENT_DATE: (state, date) => {
      state.currentDate = date
    },
    SET_EVENTS: (state, events) => {
      state.events = events
    },
    SET_HAD_INITED: (state, value) => {
      state.hadInited = value
    }
  },
  actions: {
    setCurrentView ({ commit }, view) {
      commit('SET_CURRENT_VIEW', view)
    },
    setCurrentDate ({ commit }, date) {
      commit('SET_CURRENT_DATE', date)
    },
    // 这个action在每次切换日期的时候都会被调用, 判断缓存的数据范围是否改变并更新数据
    setViewRange ({ commit, dispatch, state }, { start, end }) {
      // 第一次设置事件范围的时候,标记已初始化
      if (state.hadInited === false) {
        commit('SET_HAD_INITED', true)
      }
      if (
        state.viewRange.start.getTime() === start.getTime() &&
        state.viewRange.end.getTime() === end.getTime()
      ) {
        return
      }
      commit('SET_VIEW_RANGE', { start, end })
      dispatch('fetchData')
    },
    async fetchData ({ commit, state }) {
      commit('SET_LOADING', true)
      getTutorLessonDurationTest(state.viewRange.start, state.viewRange.end)
        .then(res => {
          commit('SET_EVENTS', res)
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },
    prev ({ commit, state, dispatch }) {
      const prev = new Date(state.currentDate.getTime())
      prev.setDate(prev.getDate() - (state.currentView ? 7 : 1))
      commit('SET_CURRENT_DATE', prev)
    },
    next ({ commit, state, dispatch }) {
      const next = new Date(state.currentDate.getTime())
      next.setDate(next.getDate() + (state.currentView ? 7 : 1))
      commit('SET_CURRENT_DATE', next)
    },
    today ({ commit, state, dispatch }) {
      commit('SET_CURRENT_DATE', new Date())
    }
  },
  getters: {
    events: state => state.events,
    currentDate: state => state.currentDate,
    currentView: state => state.currentView,
    loading: state => state.loading,
    viewRange: state => state.viewRange,
    isToday: state => isToday(state.currentDate),
    missingCommentCount: state => state.events.filter(e => e.Course && e.Course.MissingComment).length,
    hadInited: state => state.hadInited
  }
}
export default classtable
